import FormCard from "@/features/work-orders/ui/form-card"
import { TypographyH4 } from "../../../shared/components/ui/typography"
import { cn } from "../../../shared/lib/utils"
import { useDirtyFields } from "../context/dirty-fields-context"

type HomeDetailsWrapperProps = {
    children: React.ReactNode,
    heading?: string,
    wrapperClassName?: string,
    fieldNames?: string[] // Array of field names to check for dirty state
}

function HomeDetailsWrapper({ children, heading, wrapperClassName, fieldNames = [] }: HomeDetailsWrapperProps) {
    const { isFieldDirty } = useDirtyFields()
    
    // Check if any of the fields in this section are dirty
    const isDirty = fieldNames.some(fieldName => isFieldDirty(fieldName))
    
    return (
        <FormCard>
            {heading && <TypographyH4 className={cn(
                "pb-5 transition-colors duration-200",
                isDirty && "text-[#9c27b0]"
            )}>{heading}</TypographyH4>}
            <div className={cn("inputs-wrapper", wrapperClassName)}>{children}</div>
        </FormCard>
    )
}

export default HomeDetailsWrapper
